import { useState } from "react";
import Button, { ButtonVariant } from "../../ui-lib/components/Button/Button";
import CreateAlarmReceptionModal from "./CreateAlarmReception/CreateAlarmReceptionModal";
import useTranslations from "../../core/i18n/useTranslations";
import useUser from "../../core/user/useUser";

export const AddAlarmReceptionButton = ({
  buttonColor,
  icon,
  organizationId,
  refetch,
}: {
  buttonColor: ButtonVariant;
  icon?: string;
  organizationId?: number;
  refetch: () => Promise<void>;
}) => {
  const t = useTranslations();
  const { config } = useUser();
  const [addArcModalOpen, setAddArcModalOpen] = useState(false);

  return config?.show.includes("RcCreatePublic") ||
    config?.show.includes("RcCreate") ? (
    <>
      <Button
        image={icon}
        variant={buttonColor}
        text={t("AlarmReceptions:add_alarm_reception")}
        onClick={() => setAddArcModalOpen(true)}
        dataCy="add_alarm_reception_button"
      />
      <CreateAlarmReceptionModal
        isOpen={addArcModalOpen}
        onClose={() => setAddArcModalOpen(false)}
        onAdd={async () => {
          setAddArcModalOpen(false);
          await refetch();
        }}
        organizationId={organizationId}
      />
    </>
  ) : null;
};
